export const USER_PERSONALIZATION_SIZES_URL = '/member/personalization/sizes'
export const CATALOG_URL = '/catalog'
